import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { SearchAllContent } from '../../components';

import './style.scss';

const Search = () => {
  const { t } = useTranslation();

  return (
    <Container className="Search">
      <SearchAllContent>
        <div className="Search__wrapper row">
          <div className="Search__header col-12">
            <h1>{t('components.search.title')}</h1>
            <SearchAllContent.SearchBar />
          </div>
          <div className="Search__sidebar col-12 col-lg-4">
            <SearchAllContent.Facets />
          </div>
          <div className="Search__main col-12 col-lg-8">
            <div className="row">
              <div className="col">
                <SearchAllContent.Stats />
              </div>
              <div className="col-auto">
                <SearchAllContent.SortBy />
              </div>
            </div>
            <SearchAllContent.Results />
            <SearchAllContent.Pagination />
          </div>
        </div>
      </SearchAllContent>
    </Container>
  );
};

export default Search;
